module.exports = __webpack_public_path__ + "img/box02.b7c386ba.png";